import apiConfig from "../ApiConfig";

export const checkEmailApi = async (email) => {
    const response = await apiConfig.post(`/auth/check-email`, { email }, { skipAuth: true });
    return response.data; // { exists: true | false }
}

export const getUserDataApi = async () => {
    try {
        const response = await apiConfig.get(`/auth/users/me`);
        if (response.data) {
            return response.data;
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        throw error;
    }
}
export const getUserConsentApi = async (email) => {
    try {
        const response = await apiConfig.get(`/auth/users/get-consent/${email}`);
        if (response.data) {
            return response.data;
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        throw error;
    }
}
export const updateUserConsentApi = async (payload) => {
    try {
        const response = await apiConfig.put(`/auth/users/update-consent`, payload);
        if (response.data) {
            return response.data;
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        throw error;
    }
}

export const getTermsDocumentApi = async () => {
    try {
        const response = await apiConfig.get(`/api/consent/terms-document/`);
        if (response.data) {
            return response.data;
        }
        throw new Error("Failed to fetch terms document URL");
    } catch (error) {
        throw error;
    }
}

